@if (loading) {
  <div class="hidden-content">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>

  <sd-loader [theme]="loaderTheme" class="spinner"></sd-loader>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
